import { Component, input } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {
  readonly companyName = input<string>('SoftCo');
  readonly companyUrl = input<string | null>(null);

  readonly showPoweredBy = input<boolean>(true);
  readonly showCopyright = input<boolean>(true);

  readonly year = new Date().getFullYear();
}
